import MessagingQueuesMainPage from './MessagingQueuesMainPage';

export default MessagingQueuesMainPage;
